import { canonicalUrlSelector } from '@doda/common/src/redux/features/canonical';
import { queryParamsSelector } from '@doda/common/src/redux/features/queryParams';
import { useAppSelector } from 'redux/hooks';
import { createUrl } from '@doda/common/src/utils/urlUtil';
import { rewritesUrlSelector } from 'redux/features/rewritesUrl';
import { judgeSameParams } from '../../logics/judgeSameParams';
import { COND_QUERIES, NON_SEO_EFFECTIVE_PARAM } from '../../constants';

/**
 * カノニカル形式もしくは動的URLのベースとなるURLを生成するカスタムフック
 * @returns {string} カノニカル形式もしくは動的URLのベースとなるURL
 */
export const useCreateBaseUrl = (): string => {
  const rewritesUrl = useAppSelector(rewritesUrlSelector);
  const canonicalUrl = useAppSelector(canonicalUrlSelector) || '';
  const hasCanonicalPageParam = /\/-page__(\d+)/.test(canonicalUrl);
  const isCanonical = Boolean(
    canonicalUrl && judgeSameParams(rewritesUrl, canonicalUrl)
  );

  const queryParams = useAppSelector(queryParamsSelector);
  const seoCondQueries = COND_QUERIES.filter(
    (condQuery) => !NON_SEO_EFFECTIVE_PARAM.includes(condQuery)
  );
  const removedTargetParams = hasCanonicalPageParam
    ? [...seoCondQueries, 'page']
    : seoCondQueries;

  // 検索条件以外のクエリパラメータ
  const extraQueries = Object.fromEntries(
    Object.entries(queryParams).filter(
      ([key]) => !removedTargetParams.includes(key)
    )
  );

  // カノニカル形式でURLを生成できるか判定し、必要なクエリパラメータを加える
  const baseUrl = isCanonical
    ? createUrl({
        href: canonicalUrl,
        params: extraQueries,
      })
    : rewritesUrl;

  return baseUrl;
};
